export default {
	headers: {
		en: {
			message: "Message",
			date: "Date",
			to: "To"
		},

		ar: {
			message: "الرسالة",
			date: "التاريخ",
			to: "إلى"
		}
	},
	"marked-as-read": {
		en: "Marked as read",
		ar: "تحدد كمقروء"
	},
	
	search: {
		en: "Search",
		ar: "بحث"
	},

	update: {
		en: "Update",
		ar: "تحديث"
	},

	"no-matching-message-found": {
		en: "No matching message found",
		ar: "لم يتم العثور على رسالة مطابقة"
	},

	"no-messages-yet": {
		en: "No messages yet...",
		ar: "ما من رسائل بعد.. "
	},

	message: {
		en: "Message",
		ar: "رسالة"
	},

	send: {
		en: "Send",
		ar: "إرسال"
	},

	edit: {
		en: "Edit",
		ar: "تعديل"
	},

	"group-message": {
		en: "Group message",
		ar: "رسالة جماعية"
	},

	"from-the-guardian": {
		en: "From the guardian",
		ar: "من ولي الأمر"
	},

	read: {
		en: "Read",
		ar: "مقروءة"
	},

	"transmission-failed": {
		en: "Transmission failed",
		ar: "فشل الإرسال"
	},

	"it-is-being-sent": {
		en: "It is sent",
		ar: "يتم الإرسال"
	},

	sent: {
		en: "Sent",
		ar: "تم الإرسال"
	},

	copy: {
		en: "Copy",
		ar: "نسخ"
	},

	delete: {
		en: "Delete",
		ar: "حذف"
	},

	hello: {
		en: "Hello",
		ar: "اهلا و سهلا بك."
	},

	"something-went-wrong": {
		en: "Something went wrong",
		ar: " حدث خطأ ما"
	},

	"all-messages-have-been-marked-as-read": {
		en: "All messages have been marked as read",
		ar: "تم التحديد كل الرسائل كمقروء"
	},

	"the-message-was-sent": {
		en: "The message was sent",
		ar: "تم إرسال الرسالة "
	},
	
	"an-error-occurred-the-message-was-not-sent" : {
		en: "An error occurred; the message was not sent.",
		ar: "حدث خطأ ما, لم يتم الإرسال"
	},

	"try-again": {
		en: "Try again",
		ar: "إعادة المحاولة"
	}
}